module.exports = __webpack_public_path__ + "static/img/header-logo-blue.2629ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/header-logo-blue.png
// module id = F2tB
// module chunks = 4